/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Failed_To_ConnectInputs */

const en_two_fa_failed_to_connect = /** @type {(inputs: Two_Fa_Failed_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to connect to server`)
};

const nl_two_fa_failed_to_connect = /** @type {(inputs: Two_Fa_Failed_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon geen verbinding maken met de server`)
};

/**
* | output |
* | --- |
* | "Failed to connect to server" |
*
* @param {Two_Fa_Failed_To_ConnectInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_failed_to_connect = /** @type {((inputs?: Two_Fa_Failed_To_ConnectInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Failed_To_ConnectInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_failed_to_connect(inputs)
	return en_two_fa_failed_to_connect(inputs)
});